
import MainLayout from "@/components/layout/MainLayout";
import MeditationCard from "@/components/meditation/MeditationCard";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import PageSEO from "@/components/seo/PageSEO";

const GuidedMeditation = () => {
  const meditations = [
    {
      id: "1",
      title: "Respiração para Iniciantes",
      description: "Uma introdução suave à meditação focada na respiração.",
      duration: "5 minutos",
      imageUrl: "/lovable-uploads/3c6e3c80-fdf0-41d2-8c65-22c6d6b09d46.png",
      audioUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    },
    {
      id: "2",
      title: "Relaxamento Profundo",
      description: "Libere a tensão com esta meditação guiada para relaxamento profundo.",
      duration: "10 minutos",
      imageUrl: "/lovable-uploads/3c6e3c80-fdf0-41d2-8c65-22c6d6b09d46.png",
      audioUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    },
    {
      id: "3",
      title: "Mindfulness Matinal",
      description: "Comece o dia com atenção plena e intenções positivas.",
      duration: "7 minutos",
      imageUrl: "/lovable-uploads/3c6e3c80-fdf0-41d2-8c65-22c6d6b09d46.png",
      audioUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    },
    {
      id: "4",
      title: "Alívio da Ansiedade",
      description: "Acalme a ansiedade com esta meditação focada na aceitação.",
      duration: "12 minutos",
      imageUrl: "/lovable-uploads/3c6e3c80-fdf0-41d2-8c65-22c6d6b09d46.png",
      audioUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    },
    {
      id: "5",
      title: "Foco e Concentração",
      description: "Melhore o foco e a concentração com esta prática guiada.",
      duration: "8 minutos",
      imageUrl: "/lovable-uploads/3c6e3c80-fdf0-41d2-8c65-22c6d6b09d46.png",
      audioUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    },
    {
      id: "6",
      title: "Gratidão Diária",
      description: "Cultive a gratidão e a positividade em sua vida.",
      duration: "6 minutos",
      imageUrl: "/lovable-uploads/3c6e3c80-fdf0-41d2-8c65-22c6d6b09d46.png",
      audioUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    },
  ];

  const breadcrumbs = [
    {
      position: 1,
      name: "Início",
      item: "https://metrocalma.org/app"
    },
    {
      position: 2,
      name: "Meditação Guiada",
      item: "https://metrocalma.org/meditacao-guiada"
    }
  ];

  const structuredData = {
    "@type": "Service",
    "name": "Meditação Guiada metrocalma",
    "description": "Sessões de meditação guiada personalizadas para reduzir ansiedade, melhorar o foco e promover bem-estar mental.",
    "provider": {
      "@type": "Organization",
      "name": "metrocalma"
    },
    "serviceType": "Mental Health Service",
    "areaServed": "BR"
  };

  return (
    <MainLayout>
      <PageSEO 
        title="Meditação Guiada - metrocalma | Mindfulness e Bem-estar Mental"
        description="Pratique meditação guiada personalizada para reduzir ansiedade, melhorar o foco e encontrar paz interior. Sessões de 5 a 30 minutos disponíveis 24/7."
        canonicalUrl="https://metrocalma.org/meditacao-guiada"
        keywords="meditação guiada, mindfulness, ansiedade, relaxamento, bem-estar mental, paz interior"
        pageName="Meditação Guiada"
        pageType="Service"
        structuredData={structuredData}
        breadcrumbs={breadcrumbs}
      />
      
      <div className="container mx-auto py-8">
        <Card>
          <CardHeader>
            <CardTitle>Meditações Guiadas</CardTitle>
            <CardDescription>
              Escolha uma meditação para acalmar a mente e relaxar o corpo.
            </CardDescription>
          </CardHeader>
          <CardContent className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {meditations.map((meditation) => (
              <MeditationCard
                key={meditation.id}
                id={meditation.id}
                title={meditation.title}
                description={meditation.description}
                duration={meditation.duration}
                imageUrl={meditation.imageUrl}
                audioUrl={meditation.audioUrl}
              />
            ))}
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
};

export default GuidedMeditation;
